/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleUpIcon64Regular = forwardRef('ArrowFigureACircleUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M32 46.5a1.5 1.5 0 0 1-1.5-1.5V21.896l-7.94 7.94a1.5 1.5 0 0 1-2.12-2.122l8.378-8.378a4.5 4.5 0 0 1 6.364 0l8.379 8.378a1.5 1.5 0 0 1-2.122 2.122l-7.939-7.94V45a1.5 1.5 0 0 1-1.5 1.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 58C17.64 58 6 46.36 6 32S17.64 6 32 6s26 11.64 26 26-11.64 26-26 26ZM9 32c0 12.703 10.297 23 23 23s23-10.297 23-23S44.703 9 32 9 9 19.297 9 32Z" })));
});
